if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        this.submitButtonOgText = this.submitButtonText.innerHTML;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.hideAddToCartSoldOut = this.dataset.hideAddToCartSoldOut === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        if (this.submitButton.getAttribute("data-sold-out") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        // this.submitButton.classList.add('loading');
        // this.querySelector('.loading__spinner').classList.remove('hidden');
        this.submitButtonText.innerText = "Adding...";

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        //get free delivery banner
        let freeDeliveryBanner = document.querySelector(
          `free-delivery-banner[data-form-id="${this.form.getAttribute("id")}"]`
        );

        //get free item add on
        let offerElement = document.querySelector(
          `offers-banner[data-form-id="${this.form.getAttribute("id")}"]`
        );
        if (offerElement) {
          offerElement.loading = true;
        }
        if (offerElement != null && offerElement.willGetFreeGift) {
          let formObject = {};
          let originalItem = {};
          let originalItemProperties = {};
          let propertiesRegex = /^properties/;
          let idQtyRegex = /^id|^quantity/;
          for (const pair of formData.entries()) {
            if (pair[0].search(propertiesRegex) != -1) {
              let propertyKey = pair[0].replace(propertiesRegex, "").slice(1, -1);
              originalItemProperties[propertyKey] = pair[1];
            } else if (pair[0].search(idQtyRegex) != -1) {
              originalItem[pair[0]] = parseInt(pair[1]);
            }
          }
          if (Object.keys(originalItemProperties).length !== 0) {
            originalItem["properties"] = originalItemProperties;
          }
          let addOnItem = offerElement.firstAvailableOffer.getAddOnObject();
          formObject["items"] = [originalItem, addOnItem];
          formObject["sections"] = this.cart.getSectionsToRender().map((section) => section.id);
          formObject["sections_url"] = window.location.pathname;
          config.body = JSON.stringify(formObject);
        } else {
          delete config.headers["Content-Type"];
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading__spinner').classList.add('hidden');
            if (offerElement) {
              offerElement.refreshData();
            }
            if (freeDeliveryBanner) {
              freeDeliveryBanner.refreshData();
            }
            this.submitButtonText.innerText = "Added!";
            setTimeout(() => {
              this.submitButton.removeAttribute("aria-disabled");
              this.submitButtonText.innerHTML = this.submitButtonOgText;
            }, 1500);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper") ||
          this.closest(".purchase-group")?.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("data-sold-out", "true");
          if (text) {
            this.submitButtonText.textContent = text;
            let dynamicButtons = this.querySelector(".shopify-payment-button");
            if (dynamicButtons) {
              dynamicButtons.style.display = "none";
            }
            let klarna = this.querySelector("klarna-placement");
            if (klarna) {
              klarna.style.display = "none";
            }
            if (this.hideAddToCartSoldOut) {
              this.submitButton.classList.add("hidden");
            }
          }
        } else {
          this.submitButton.classList.remove("hidden");
          this.submitButton.removeAttribute("disabled");
          this.submitButton.removeAttribute("data-sold-out");
          this.submitButtonText.innerHTML = `${window.variantStrings.addToCartProductPage} ${window.variantStrings.addToCartProductPageSVG}`;
          let dynamicButtons = this.querySelector(".shopify-payment-button");
          if (dynamicButtons) {
            dynamicButtons.style.display = "";
          }
          let klarna = this.querySelector("klarna-placement");
          if (klarna) {
            klarna.style.display = "";
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
